import Dash from './Dash/Dash';
import Head from './Head/Head';
import Invoices from './Invoices/Invoices';
import Jobs from './Jobs/Jobs';
import Login from './Login/Login';
import Registration from './Login/Registration';
import ForgotPassword from './Login/ForgotPassword';
import LoginAsAdmin from './LoginAsAdmin/LoginAsAdmin';
import Nav from './Nav/Nav';
import Overview from './Overview/Overview';
import Supplies from './Supplies/Supplies';
import Templates from './Templates/Templates';
import PrepaidRequest from './PrepaidRequest/PrepaidRequest';
import ResourcesIframe from './ResourcesIframe/ResourcesIframe';
import Logout from './Login/Logout';

export {
  Dash,
  Head,
  Invoices,
  Jobs,
  Login,
  Registration,
  ForgotPassword,
  LoginAsAdmin,
  Nav,
  Overview,
  Supplies,
  Templates,
  ResourcesIframe,
  Logout,
  PrepaidRequest,
};



// WEBPACK FOOTER //
// ./src/containers/index.js